import styled from "styled-components";
import colors from "../../../../../styles/colorPalette";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: left;
  justify-content: center;
  width: 100%;
  height: 52px;
  margin-bottom: 80px;
  box-sizing: border-box;
  @media (max-width: 1400px) {
    margin-bottom: 38px;
  }
`;

export const Title = styled.div`
  display: flex;
  font-family: "OpenSansRegular";
  font-size: 48px;
  font-weight: 300;
  color: ${colors.orange1};
  box-sizing: border-box;
  @media (max-width: 1400px) {
    width: 1087px;
    height: 500px;
    font-size: 36px;
  }
`;
